import { Bi, BiDetail } from "../types/bi";
import api from "./api";

export const listBi = async (): Promise<Bi[]> => {
  const response = await api.get(
    "config-p1-:stage/:stage/crm/getConfigSubmenuPai"
  );
  return response.data;
};

export const listBiDetail = async (id: string): Promise<BiDetail[]> => {
  const response = await api.get(
    "config-p1-:stage/:stage/crm/getConfigSubmenuFilho",
    { params: { idSubmenuPai: id } }
  );
  return response.data;
};

export const findDashboard = async (id: string): Promise<string> => {
  const response = await api.get(
    "config-p1-:stage/:stage/crm/getDashboardMetabase",
    {
      params: { id_dashboard: id },
    }
  );
  return response.data.iframeUrl;
};
